import { render, staticRenderFns } from "./SaveAgbFromEditor.vue?vue&type=template&id=c68633c8&"
import script from "./SaveAgbFromEditor.vue?vue&type=script&lang=js&"
export * from "./SaveAgbFromEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports